<template>
  <div>
    <v-container>
      <div class="nav nav-tabs" style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap">
        <template v-for="(item, index) in tabs">
          <v-btn
            :key="`tab-${index + 1}`"
            depressed
            class="ma-1"
            :outline="currentTab !== item.value"
            :color="currentTab !== item.value ? 'grey' : 'primary'"
            @click="currentTab = item.value"
            >{{ item.label }}</v-btn
          >
        </template>
      </div>
      <div class="mt-2 pt-4" style="border-top: 2px solid #ee6e73">
        <div class="mb-4">
          <date-filter
            ref="datefilter"
            v-model="selectedDate"
            :default-filter="'last_7_days'"
          ></date-filter>
        </div>
        <template v-if="currentTab === 'dashboard'">
          <Dashboard :selected-date="selectedDate" />
        </template>
        <template v-if="currentTab === 'metric'">
          <Metric :selected-date="selectedDate" />
        </template>
        <template v-if="currentTab === 'customer'">
          <Customer :selected-date="selectedDate" />
        </template>
      </div>
    </v-container>
  </div>
</template>

<script>
import Dashboard from './Dashboard'
import Metric from './Metric'
import Customer from './Customer'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import dayjs from 'dayjs'
import beaconApi from '@/api/beacon'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'

export default {
  components: {
    Dashboard,
    Metric,
    Customer,
    DateFilter
  },
  data() {
    return {
      currentTab: 'dashboard',
      selectedDate: {
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      },
      tabs: [
        { label: this.$t('Dashboard'), value: 'dashboard' },
        { label: this.$t('Metrics'), value: 'metric' },
        { label: this.$t('Customer'), value: 'customer' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    await this.getBeaconsList()
  },
  methods: {
    async getBeaconsList() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await beaconApi.getBeaconsList({
          pageId: vm.selectedBot.pageid,
          config: { limit: 1000, offset: 0 }
        })
        vm.$store.commit('CLEAR_LOADING')
        handleResponse(response)
        if (response && response.status === 200 && response.data && response.data.success) {
          const tempResult = response.data.result || []
          vm.$store.state.beaconMasterData.beaconBranch = tempResult
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Analytics/Analytics.vue